import { AxiosRequestConfig } from 'axios';
import { DEFAULT_STORE_CODE, SOLEPRO_STORE_CODE} from '../constants/store';

export const getStoreCodeForRequests = req => {
  let storeCode = req.headers.store ?? DEFAULT_STORE_CODE;
      try {
        storeCode = req.headers.cookie.split(';').find(el => el.includes('24orepro-vsf-store')).split('=')[1]
      } catch (e) { }
      
  return storeCode;
}


export const appendStylesFromText = (cssText, media = 'screen') => {
  if (process.client && document) {
    const el = document.createElement('style');
    // WebKit hack
    el.append(document.createTextNode(''));
    el.type = 'text/css';
    el.media = media;
    el.innerHTML = cssText;
    document.head.append(el);
  }
};

/** This function removes all empty entries (null or empty string)  */
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
export const removeEmptyValuesFromObject = (obj) => Object.fromEntries(Object.keys(obj)
  .filter((k) => obj[k] != null && obj[k] != '')
  .map((k) => [k, obj[k]]));

const valueToHex = (c) => {
  const hex = Number.parseInt(c as string).toString(16);
  return hex.length == 1 ? `0${hex}` : hex;
};

export const rgbaToHex = (rgba) => {
  const [r, g, b, a] = rgba.replace(/rgba?\(|\)|\s/g, '').split(',');
  return {
    color: `#${valueToHex(r)}${valueToHex(g)}${valueToHex(b)}`,
    opacityPercentage: Number.parseInt(Math.round(a * 100).toString()),
  };
};

const calculateTintAndShade = (
  hexColor, // using #663399 as an example
  percentage = 0.1 // using 10% as an example
) => {
  const r = parseInt(hexColor.slice(1, 3), 16); // r = 102
  const g = parseInt(hexColor.slice(3, 5), 16); // g = 51
  const b = parseInt(hexColor.slice(5, 7), 16); // b = 153

  /* 
     From this part, we are using our two formulas
     in this case, here is the formula for tint,
     please be aware that we are performing two validations
     we are using Math.min to set the max level of tint to 255,
     so we don't get values like 280 ;)
     also, we have the Math.round so we don't have values like 243.2
     both validations apply for both tint and shade as you can see */
  const tintR = Math.round(Math.min(255, r + (255 - r) * percentage)); // 117
  const tintG = Math.round(Math.min(255, g + (255 - g) * percentage)); // 71
  const tintB = Math.round(Math.min(255, b + (255 - b) * percentage)); // 163

 
  const shadeR = Math.round(Math.max(0, r - r * percentage)); // 92
  const shadeG = Math.round(Math.max(0, g - g * percentage)); // 46
  const shadeB = Math.round(Math.max(0, b - b * percentage)); // 138


  /* 
     Now with all the values calculated, the only missing stuff is 
     getting our color back to hexadecimal, to achieve that, we are going
     to perform a toString(16) on each value, so we get the hex value
     for each color, and then we just append each value together and voilà!*/
  return {
      tint: {
          r: tintR,
          g: tintG,
          b: tintB,
          hex:
              '#' +
              [tintR, tintG, tintB]
                  .map(x => x.toString(16).padStart(2, '0'))
                  .join(''), // #7547a3 
      },
      shade: {
          r: shadeR,
          g: shadeG,
          b: shadeB,
          hex:
              '#' +
              [shadeR, shadeG, shadeB]
                  .map(x => x.toString(16).padStart(2, '0'))
                  .join(''), // #5c2e8a 
      },
  };
};

export const DarkenColor = (hexColor, percentage) => {
  return calculateTintAndShade(hexColor, percentage).shade.hex
}

/**
 * In the css_classes magento field the column char is not allowed
 * We can use triple underscore to manage this behavior.
 * In order to manage tailwind media classes like md:bg-red lg:bg-white
 * we can use md___bg-red lg___bg-white and the replace ___ with : to use them in html
 */
export const parseClasses = (text: string) => {
  const replacements: { [key: string]: string } = {
    '_open_square_bracket_': '[',
    '_osb_': '[',
    '_csb_': ']',
    '_close_square_bracket_': ']',
    '_open_round_bracket_': '(',
    '_close_round_bracket_': ')',
    '_orb_': '(',
    '_crb_': ')',
    '!solepro_hidden': '!hidden',
    'solepro_hidden': 'hidden',
    '_slash_': '/',
    '_important_': '!',
    '_imp_': '!',
    '_percentage_': '%',
    '_AND_': '&',
    '_STAR_': '*',
    '_IN_': '>',
    '___': ':',
    '_DOT_': '.',
  };

  // Creiamo una regex che combini tutte le chiavi (le stringhe da sostituire)
  // in un unico pattern. Usiamo 'g' per la sostituzione globale (tutte le occorrenze)
  // e 'gi' per rendere la regex case-insensitive se necessario, ma in questo caso
  // non sembra esserlo dalle tue stringhe originali.
  // Escapiamo i caratteri speciali per la regex come '!', '(', ')' ecc.
  const pattern = new RegExp(Object.keys(replacements).map(key =>
    key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  ).join('|'), 'g');

  return text.replace(pattern, (match) => replacements[match]);
};

export const getAxiosConfigs = (app, config) => {
  
  let axiosConfigs: AxiosRequestConfig = {
    headers: {
      Store: DEFAULT_STORE_CODE
    }
  }
  
  if (app.$config.soleEnv == 'local') {
    axiosConfigs.baseURL = `http://${app.$config.localURL}`
  } else {
    axiosConfigs.baseURL = `${app.$config.soleproDomain}`
  }

  return {
    ...axiosConfigs
  }

} 

export const calcolaBoxInWidth = (spazioTotale) => {
  // Larghezza di un singolo box
  const larghezzaBox = 340;
  // Larghezza dello spazio tra i box
  const spazioTraBox = 20;

  // L'unità di calcolo è la larghezza di un box più lo spazio successivo
  // Ad eccezione del primo box
  const unita = larghezzaBox + spazioTraBox;

  // Sottraiamo lo spazio occupato dal primo box
  const spazioRimanente = spazioTotale - larghezzaBox;

  // Se lo spazio totale non è sufficiente neanche per il primo box, non ci sono box.
  if (spazioRimanente < 0) {
    return 0;
  }

  // Calcoliamo quanti box "aggiuntivi" (con il loro spazio) ci stanno
  const boxAggiuntivi = Math.floor(spazioRimanente / unita);

  // Il numero totale di box è 1 (il primo) + i box aggiuntivi
  const totaleBox = 1 + boxAggiuntivi;

  return totaleBox;
}


export const isElementInViewport = (element)=> {
    // getBoundingClientRect() ci dà la posizione (top, bottom, left, right)
    // dell'elemento rispetto al viewport.
    const rect = element.getBoundingClientRect();

    // Controlliamo se una parte dell'elemento è all'interno del viewport.
    // L'elemento è visibile se:
    // 1. Il suo bordo superiore (rect.top) è sopra o all'interno del fondo del viewport (window.innerHeight)
    // 2. E il suo bordo inferiore (rect.bottom) è sotto o all'interno dell'alto del viewport (0)

    // Inoltre, è necessario che i valori non siano 0 per un elemento senza dimensioni.
    return (
        rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
        rect.bottom > 0 &&
        rect.right > 0 && 
        rect.left < (window.innerWidth || document.documentElement.clientWidth)
    );
}